import React from 'react';
import { Button } from '@milanote/roma';
import { useDispatch } from 'react-redux';

import { deleteTag } from '../../../../../../../common/tags/tagActions';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';

import { isEmpty } from 'lodash';
import { Trash03 } from '@untitledui/icons';
import { TagEditContentProps } from './TagEditContent';

const TagDeleteButton: React.FC<TagEditContentProps> = ({ tag, tagElements, closePopup }) => {
    const translate = useTranslator('popup', 'tags.edit');
    const elementCount = isEmpty(tagElements) ? 0 : tagElements.length;
    const dispatch = useDispatch();

    const handleDeleteTag = () => {
        if (!tag) return;

        dispatch(deleteTag(tag.id));
        closePopup();
    };

    return (
        <div className="TagDeleteButton w-full flex justify-start mt-2">
            <Button className="" iconLeading={Trash03} onClick={handleDeleteTag} size={'sm'} color={'tertiary'}>
                <div className="flex items-center gap-2">
                    <span className="text-sm">{translate('delete')}</span>
                    {elementCount > 0 && (
                        <span className="text-xs text-gray-400">{translate('used', { count: elementCount })}</span>
                    )}
                </div>
            </Button>
        </div>
    );
};

export default TagDeleteButton;
